import type { ReviewFindingSeverity } from '../types';

export interface FindingSeverityAppearance {
  surface: string;
  border: string;
  foreground: string;
}

export const FINDING_SEVERITY_APPEARANCE: Readonly<
  Record<ReviewFindingSeverity, FindingSeverityAppearance>
> = {
  low: {
    surface: '#FEF3C7',
    border: '#B45309',
    foreground: '#78350F',
  },
  medium: {
    surface: '#FFEDD5',
    border: '#C2410C',
    foreground: '#7C2D12',
  },
  high: {
    surface: '#FEE2E2',
    border: '#B91C1C',
    foreground: '#7F1D1D',
  },
  critical: {
    surface: '#DC2626',
    border: '#991B1B',
    foreground: '#FFFFFF',
  },
};

export const getFindingSeverityAppearance = (
  severity: ReviewFindingSeverity | null | undefined
): FindingSeverityAppearance | undefined =>
  severity ? FINDING_SEVERITY_APPEARANCE[severity] : undefined;
